import { PlotPanelState } from "@/shared/state/visualization";

import { DisplayEventsButton } from "./DisplayEventsButton";
import { LegendButton } from "./LegendButton";
import { MoveTool } from "./MoveTool";
import { SelectRegionTool } from "./SelectRegionTool";
import { SyncViewportButton } from "./SyncViewportButton";
import { ZoomTool } from "./ZoomTool";

interface ToolbarProps {
  state: PlotPanelState;
}

export function Toolbar({ state }: ToolbarProps) {
  return (
    <>
      <SyncViewportButton config={state.config} />
      <ZoomTool />
      <MoveTool />
      <SelectRegionTool />
      <LegendButton />
      <DisplayEventsButton state={state} />
    </>
  );
}
